import { render, staticRenderFns } from "./SohChart.vue?vue&type=template&id=17190d9f&scoped=true&"
import script from "./SohChart.vue?vue&type=script&lang=js&"
export * from "./SohChart.vue?vue&type=script&lang=js&"
import style0 from "./SohChart.vue?vue&type=style&index=0&id=17190d9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17190d9f",
  null
  
)

export default component.exports